<template>
  <div class="content">
    <div class="title">{{ $t('common.step.4') }}</div>
    <!--    {{ form }}-->
    <!--    {{ currentMassEmailObj }}-->
    <div class="box_inner">
      <el-form
          ref="ruleFormRef"
          :model="form"
          label-width="120px"
          class="demo-ruleForm"
          :rules="rules"
          :label-position="'top'"
      >
        <el-form-item :label="$t('common.step.search.2')" prop="taskName">
          <el-input
              v-model="form.taskName"
              :placeholder="$t('90201')"
              style="width: 50%"
          ></el-input>
        </el-form-item>
        <el-form-item
            v-for="(item, index) in form.subjectList"
            :key="index"
            :prop="`subjectList.${index}.content`"
            :rules="[
                { required: true, message: $t('common.email.contentCannotBeEmpty'), trigger: ['blur', 'change'] }
            ]"
            :label="index === 0 ? $t('sending.table.col.title') : ''"
        >
          <template #default>
            <el-input
                v-model="form.subjectList[index].content"
                class="add_inputs"
                :placeholder="$t('common.subject.form')"
                style="width: 50%"
                show-word-limit
                maxlength="300"
            ></el-input>
            <div
                class="setting_box"
                v-if="true"
            >
              <el-button
                  style="margin-left: 0px !important;"
                  @click="removeSubject(index,form.subjectList[index].content)"
                  type="danger"
                  link
                  v-if="form.subjectList.length!==1"
              >
                {{ $t('common.delete') }}
              </el-button>
              <div class="add_button" v-if="index===0">
                <el-button v-if="!(form.subjectList.length>4)" size="small" @click="addSubject" type="primary"
                           :icon="Plus"
                           text>{{
                    $t('common.add')
                  }}
                </el-button>
              </div>
            </div>
            <div v-else class="setting_box"></div>
          </template>
        </el-form-item>
        <el-form-item :label="$t('common.send.email.box')" prop="mailMassConfigDtoList">
          <el-select
              v-model="form.mailMassConfigDtoList"
              class="mailselectEl"
              multiple
              remote
              :placeholder="$t('common.please.input')"
              style="width: 50%"
              :value-key="'configId'"
          >
            <el-option
                v-for="item in userMail_dropDownOptionList"
                :key="item.configId"
                :label="item.from"
                :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('common.step.form.replay')" prop="replyTo">
          <el-select
              v-model="form.replyTo"
              class="mailselectEl"
              remote
              allow-create
              :placeholder="$t('common.please.input')"
              style="width: 50%"
          >
            <el-option
                v-for="item in userMail_dropDownOptionList"
                :key="item.configId"
                :label="item.from"
                :value="item.configId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('common.step.txt.3')" prop="nickName">
          <el-input
              v-model="form.nickName"
              :placeholder="$t('common.step.nick.name')"
              style="width: 50%"
          ></el-input>
        </el-form-item>
        <el-form-item prop="isCheckCC">
          <template #default>
            <div style="display: flex;flex-direction: column;width: 50%;">
              <el-checkbox
                  v-model="form.isCheckCC"
                  :label="$t('common.add.cc')"
                  size="large"
              />
              <el-select
                  v-if="form.isCheckCC"
                  v-model="form.cc"
                  class="mailselectEl"
                  style="width: 100%;"
                  remote
                  multiple
                  filterable
                  allow-create
                  default-first-option
                  :reserve-keyword="false"
                  :placeholder="$t('common.please.input')"
                  @focus="(event) => handleFocus(event, 'cc')"
              >
              </el-select>
            </div>
          </template>
        </el-form-item>
        <el-form-item prop="isCheckBCC">
          <template #default>
            <div style="display: flex;flex-direction: column;width: 50%;">
              <el-checkbox
                  v-model="form.isCheckBCC"
                  :label="$t('common.add.bcc')"
                  size="large"
              />
              <el-select
                  v-if="form.isCheckBCC"
                  v-model="form.bcc"
                  class="mailselectEl"
                  style="width: 100%;"
                  remote
                  multiple
                  filterable
                  allow-create
                  default-first-option
                  :reserve-keyword="false"
                  :placeholder="$t('common.please.input')"
                  @focus="(event) => handleFocus(event, 'bcc')"
              >
              </el-select>
            </div>
          </template>
        </el-form-item>
        <el-form-item prop="sendTime" v-if="sessionStore.get('STEP_0_SELECT_TYPE')!== 1">
          <template #label>
            <div style="display: flex;justify-content: flex-start;align-items: center">
              <span style="font-weight: 700;color: #606266">{{ $t('common.send.timing') }}</span>
              <span style="margin-left: 20px;">
                <el-checkbox
                    v-model="form.checked1Time"
                    :label="$t('common.step.nick.option1')"
                    size="large"
                />
                <el-checkbox
                    v-model="form.checked2Location"
                    :label="$t('common.step.nick.option2')"
                    size="large"
                />
              </span>
            </div>
          </template>
          <template #default>
            <div style="display: flex;flex-direction: column" v-if="form.checked1Time">
              <div style="display: flex;">
                <div style="width: 90px;font-weight: 700;color: #606266">{{ $t('common.cds64') }}</div>
                <el-select v-model="form.zoneAddress" :placeholder="$t('common.country')"
                           filterable class="select_country"
                           popper-class="sp_country"
                           style="width: 340px;"
                >
                  <el-option
                      v-for="item in areaList"
                      :key="item.country"
                      :label="lang!=='zh-CN'?item.countryEn:item.country"
                      :value="lang!=='zh-CN'?item.countryEn:item.country"
                  />
                </el-select>
              </div>
              <div style="display: flex;margin-top: 10px;">
                <div style="width: 90px;font-weight: 700;color: #606266">{{ $t('common.email.sendTime') }}</div>
                <el-date-picker
                    v-model="form.sendTime"
                    type="datetime"
                    style="width: 340px;"
                    :disabled-date="disabledDate"
                    format="YYYY-MM-DD HH:mm:ss"
                    value-format="YYYY-MM-DD HH:mm:ss"
                    :placeholder="$t('common.please.select')"
                    @change="handleChangeSendTime"
                >
                </el-date-picker>
              </div>
            </div>
            <div v-else-if="form.checked2Location" style="display: flex;margin-top: 10px;">
              <div style="width: 90px;font-weight: 700;color: #606266">{{ $t('common.email.sendTime') }}</div>
              <el-date-picker
                  v-model="form.sendTime"
                  type="datetime"
                  style="width: 340px;"
                  :disabled-date="disabledDate"
                  @change="handleChangeSendTime"
                  format="YYYY-MM-DD HH:mm:ss"
                  value-format="YYYY-MM-DD HH:mm:ss"
                  :placeholder="$t('common.please.select')">
              </el-date-picker>
            </div>
          </template>
        </el-form-item>
        <el-form-item :label="$t('common.step.remark')" prop="remark">
          <el-input
              v-model="form.remark"
              :placeholder="$t('common.please.input')"
              style="width: 50%"
              :maxlength="30"
              show-word-limit
              clearable
              type="text"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('common.step.send.time.step')" prop="stepTime">
          <template #default>
            <el-select class="sp_select"
                       v-model="form.massSendSecond"
                       :placeholder="$t('common.please.select')"
                       style="width: 25%"
                       clearable
                       @change="handleChangeTime"
            >
              <el-option
                  v-for="item in computedOptionTime"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              />
            </el-select>
            <div style="margin-left: 10px;">
              <span>{{ $t('common.times.step') }}</span>
              <span style="color:#1890FF;margin: 0px 5px;">{{ allTimes }}</span>
              <span>{{ $t('common.times.step.con') }}</span>
            </div>
          </template>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script setup>
import {computed, onMounted, reactive, ref, watch} from "vue";
import {i18n} from "@/lang";
import img1 from "@/assets/Marketing/1@2x.png"
import img2 from "@/assets/Marketing/2@2x.png"
import {useStore} from "vuex";
import {useRoute, useRouter} from "vue-router";
import CountrySelect from "@/components/CountrySelect/index.vue";
import {getMailConfigList} from "@/api";
import {Plus} from "@element-plus/icons-vue";
import {UserTable} from "@/views/Marketing/db_user";
import dayjs from "dayjs";
import sessionStore from "@/utils/sessionStore";
import {isEmpty} from "@/utils/mylodash";

const store = useStore();
const router = useRouter();
const route = useRoute()

const userMail_dropDownOptionList = ref([]);
const configMapSysUser = reactive({});
const configIdMapUserName = reactive({});
const userNameMap = reactive({});
const teamId = computed(() => store.state.email.teamID);
const lang = computed(() => store.state.system.langLocal)
const areaList = computed(() => store.state.customer.areaList);

const props = defineProps({
  currentMassEmailObj: {
    type: Object,
    default: () => ({})
  },
})

const options = [
  {
    value: 1,
    label: i18n.global.t('common.step.txt.select.1'),
  },
  {
    value: 2,
    label: i18n.global.t('common.step.txt.select.2'),
  },
  {
    value: 3,
    label: i18n.global.t('common.step.txt.select.3'),
  },
  {
    value: 4,
    label: i18n.global.t('common.step.txt.select.4'),
  },
  {
    value: 5,
    label: i18n.global.t('common.step.txt.select.5'),
  },
  {
    value: 6,
    label: i18n.global.t('common.step.txt.select.6'),
  },
  {
    value: 7,
    label: i18n.global.t('common.step.txt.select.7'),
  },
  {
    value: 8,
    label: i18n.global.t('common.step.txt.select.8'),
  },
]

const computedTaskName = computed(() => {
  const type = sessionStore.get("STEP_0_SELECT_TYPE")
  const optionsName = options.find(item => item.value === type)
  if (optionsName?.label) {
    return `${optionsName?.label ? optionsName?.label : ''}${i18n.global.t('common.task')}${dayjs(new Date()).format("YYMMDD")}`
  } else {
    return null;
  }
})

const form = ref({
  taskName: computedTaskName.value,
  subjectList: [{content: ""}],
  mailMassConfigDtoList: [],
  nickName: "",
  zoneAddress: i18n.global.t('common.country.code.CN'),
  sendTime: "",
  remark: "",
  // 回复邮箱
  replyTo: "",
  massSendSecond: 0,
  checked1Time: false,
  checked2Location: false,
  isCheckCC: false,
  isCheckBCC: false,
  to: [],
  cc: [],
  bcc: []
})

const startCache = () => {
  // 2️⃣ 初始化时读取缓存
  // const cache = route.query.taskId ? props.currentMassEmailObj : sessionStore.get("STEP_3_EMAIL_FORM_DATA")
  const cache = sessionStore.get("STEP_3_EMAIL_FORM_DATA")
  console.log(cache, 'cache')
  if (cache) {
    try {
      Object.assign(form.value, cache)
      console.log("✅ 表单数据已从缓存恢复")
    } catch (e) {
      console.warn("⚠️ 缓存格式错误，已忽略", e)
    }
  }
}

const selectWays = ref(sessionStore.get('STEP_0_SELECT_WAYS'))

const computedOptionTime = computed(() => {
  if (selectWays.value === 1) {
    return optionsTime.value
  }
  if (selectWays.value === 2) {
    return optionsTimeSmart.value
  }
  return []
})

watch(
    () => selectWays.value,
    (ways) => {
      const cache = sessionStore.get('STEP_3_EMAIL_FORM_DATA') || {}

      // 1️⃣ massSendSecond 永远以 ways 为准
      if (ways === 1) {
        form.value.massSendSecond = 120
      } else if (ways === 2) {
        form.value.massSendSecond = 60
      } else {
        form.value.massSendSecond = 0
      }

      // 2️⃣ 其它字段：form 有值就不覆盖
      Object.keys(cache).forEach((key) => {
        if (key === 'massSendSecond') return
        if (key === 'taskName') return;
        form.value[key] = cache[key]
      })

      // 3️⃣ 同步回 session
      sessionStore.set('STEP_3_EMAIL_FORM_DATA', {
        ...form.value
      })
    },
    {immediate: true}
)

// const computedOptionTime = computed(() => {
//   const ways = sessionStore.get('STEP_0_SELECT_WAYS')
//   console.log(ways, form.value, 'ways')
//   if (ways === 1) {
//     form.value.massSendSecond = 120;
//     return optionsTime.value;
//   } else if (ways === 2) {
//     form.value.massSendSecond = 60;
//     return optionsTimeSmart.value;
//   } else {
//     form.value.massSendSecond = 0;
//     return []
//   }
// })

const optionsTime = ref([{
  label: "120",
  value: 120,
}, {
  label: "150",
  value: 150,
}, {
  label: "180",
  value: 180,
}])
const optionsTimeSmart = ref([{
  label: "30",
  value: 30
},
  {
    label: "60",
    value: 60,
  }, {
    label: "90",
    value: 90,
  }, {
    label: "120",
    value: 120,
  }, {
    label: "180",
    value: 180,
  }, {
    label: "240",
    value: 240,
  }, {
    label: "300",
    value: 300,
  }])

const handleChangeSelect = (val) => {
  console.log(val, 'val')
  form.value.replyTo = val;
}

function disabledDate(date) {
  return date.getTime() < Date.now();
}

const rules = ref({
  taskName: [{
    required: true,
    message: i18n.global.t('common.email.contentCannotBeEmpty'),
    trigger: ["blur", "change"]
  }],
  mailMassConfigDtoList: [{
    required: true,
    message: i18n.global.t('common.email.contentCannotBeEmpty'),
    trigger: ["blur", "change"]
  }],
  replyTo: [{
    required: true,
    message: i18n.global.t('common.email.contentCannotBeEmpty'),
    trigger: ["blur", "change"]
  }]
})

// const checked1Time = ref(true)
// const checked2Location = ref(false)
// 互斥监听
// watch(
//     () => form.value.checked1Time,
//     (val) => {
//       if (val) {
//         form.value.sendTime = dayjs().format("YYYY-MM-DD HH:mm:ss")
//         form.value.checked2Location = false
//       } else if (!form.value.checked2Location) {
//         // 如果两个都没选，强制恢复这个为 true
//         form.value.checked1Time = true
//       }
//     },
//     {immediate: true}
// )
//
// watch(
//     () => form.value.checked2Location,
//     (val) => {
//       if (val) {
//         form.value.sendTime = dayjs().format("YYYY-MM-DD HH:mm:ss")
//         form.value.checked1Time = false
//       } else if (!form.value.checked1Time) {
//         // 如果两个都没选，强制恢复这个为 true
//         form.value.checked2Location = true
//       }
//     },
//     {immediate: true}
// )

watch(
    () => form.value.checked1Time,
    (val) => {
      if (val) {
        // 如果选中时间，则取消位置
        form.value.checked2Location = false
      }
    }
)

watch(
    () => form.value.checked2Location,
    (val) => {
      if (val) {
        // 如果选中位置，则取消时间
        form.value.checked1Time = false
      }
    }
)

// 3️⃣ 监听变化自动写入缓存
watch(
    props.currentMassEmailObj,
    (val) => {
      Object.assign(form.value, val)
    },
    {deep: true}
)

watch(() => form.value.massSendSecond, (newValue) => {
  if (newValue) {
    console.log(newValue, 'newValue')
  }
})

function initUserMailList() {
  // currentMailId = this.mailConfigId;
  return getMailConfigList({teamId: teamId.value}).then((res) => {
    console.log(res, '获取用户邮箱列表');
    if (res.code === 200) {
      // const mailMassConfigDtoList = res.data.data[0].id
      res.result = res.result || [];
      const arr = [];
      res.result.forEach((item) => {
        configMapSysUser[item.id] = item.sysUserId;
        configIdMapUserName[item.username] = item.id;
        userNameMap[item.id] = item.username;
        arr.push({from: item.username, configId: item.id});
      });
      userMail_dropDownOptionList.value = arr;
    }
  });
}

const handleChangeSendTime = (val) => {
  getAllTime()
}

const allTimes = ref('')

const getSafeStartTime = () => {
  const rawTime = form.value.sendTime || sessionStore.get("marketing_time")

  // 如果为空直接用当前时间
  if (!rawTime) {
    return dayjs()
  }

  const d = dayjs(rawTime)

  // 如果是非法日期，用当前时间兜底
  if (!d.isValid()) {
    console.warn('非法日期:', rawTime)
    return dayjs()
  }

  return d
}

const getAllTime = async () => {
  const allCustomer = await UserTable.getAll()

  const validEmails = allCustomer
      .map(item => item.email)
      .filter(email => email && email.trim() !== '')

  const startDay = getSafeStartTime()

  if (validEmails.length > 0) {
    const interval = form.value.massSendSecond
        ? Number(form.value.massSendSecond) + 45
        : 0

    const totalSeconds = interval * validEmails.length

    allTimes.value = startDay
        .add(totalSeconds, 'second')
        .format("YYYY-MM-DD HH:mm:ss")
  } else {
    // 没客户默认 +10分钟
    allTimes.value = startDay
        .add(10, 'minute')
        .format("YYYY-MM-DD HH:mm:ss")
  }
}

// 在指定时间上加上秒数
function addSecondsToTime(startTime, seconds) {
  return dayjs(startTime)
      .add(seconds, 'second')
      .format('YYYY-MM-DD HH:mm:ss')
}


onMounted(async () => {
  await initUserMailList();
  await getAllTime()
  // await getFormDetail()
  await startCache()
})

const handleChangeTime = async (val) => {
  form.value.massSendSecond = val;
  getAllTime()
}


const removeSubject = (index, item) => {
  console.log(index, item)
  form.value.subjectList.splice(index, 1)
}

const addSubject = () => {
  // if(form.value.subject.length>4){
  //   ElMessage.warning(i18n.global.t('common.subject.form.max'))
  //   return
  // }
  form.value.subjectList.push({content: ""})
}

const activeSelectProp = ref(null);

function handleFocus(event, type) {
  activeSelectProp.value = type;
}

const ruleFormRef = ref(null);
const isValid = ref(false)
const handleSubmitForm = () => {
  return new Promise((resolve) => {
    ruleFormRef.value.validate((valid, fields) => {
      isValid.value = valid
      resolve(valid) // ✅ 验证完成后返回结果
    })
  })
}

defineExpose({
  handleSubmitForm,
  form,
  isValid,
})
</script>

<style lang="less" scoped>
.content {
  margin: 0px auto;
  height: 100%;
  width: 900px;
  text-align: left;

  .title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #000000;
  }

  .box_inner {
    padding: 20px;
    margin-top: 10px;
    max-height: calc(100vh - 270px);
    overflow: scroll;
    background: #FAFAFA;
  }
}

.setting_box {
  width: 160px;
  padding-left: 10px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

:deep(.el-form-item) {
  margin-bottom: 16px !important;
}

:deep(.el-checkbox.el-checkbox--large) {
  height: 32px !important;
}
</style>